import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getWeeklyPlan } from '../../services/health-content';

import WorkoutCard from './WorkoutCard';
import Header from '../../components/common/Header';
import LoadingComponent from '../../components/common/LoadingComponent';
import ResetWorkoutButton from '../../components/common/ResetWorkoutButton';

import PageIcon from '../../images/health-content/page-icon.svg';
import ArrowRight from '../../images/health-content/arrow-right.svg';
import Goal from "../../images/health-content/Goal-bull's-eye.svg";

const OuterContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  align-items: stretch;
  overflow: hidden;
  background: white;
`;

const BodyContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 16px;
  padding-bottom: 100px;
`;

export default function WeeklyPlan() {
  const history = useHistory();
  const { authToken } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(true);
  const [plan, setPlan] = useState([]);
  const [goalCard, setGoalCard] = useState(null);

  function navigateBack() {
    history.goBack();
  }

  const getPlan = async () => {
    try {
      const data = await getWeeklyPlan(authToken);
      setPlan(data.planDetails.timeLine);
      setGoalCard(data.planDetails.goalCard);
    } catch (error) {
      console.error('Error fetching weekly plan:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPlan();
  }, []);

  return (
    <OuterContainer className="w-100 h-screen flex flex-col bg-textbox">
      <Header hideBackButton icon={PageIcon} title={'Your workout plan'}>
        <ResetWorkoutButton setLoading={setLoading} />
      </Header>

      <BodyContainer>
        {loading ? (
          <LoadingComponent />
        ) : (
          <>
            <div
              className="border border-txtlight-shades4 mb-16px"
              style={{
                borderRadius: '12px',
              }}
            >
              <div
                className="flex items-center gap-4px bg-green-shades2 bg-opacity-10 py-14px px-12px"
                style={{
                  borderRadius: '12px 12px 0px 0px',
                }}
              >
                <img src={Goal} />
                <div className="text-body-l">
                  <span className="text-txtsecondary font-medium">Goal:</span>{' '}
                  <span className="text-txtlight font-bold">
                    {goalCard?.title}
                  </span>
                </div>
              </div>
              <div className=" py-14px px-16px flex flex-col gap-4px">
                {goalCard?.targets?.map((val) => {
                  return (
                    <div className="flex items-center text-txtlight text-body-s">
                      <img src={val.icon} height={12} width={12} />
                      <span className="pl-12px pr-8px font-medium ">
                        {val.title}
                      </span>
                      <span>:</span>
                      <span className="font-semibold pl-8px pr-8px">
                        {val.value}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
            {plan.map((val, index) => (
              <div className="pb-10px">
                <WorkoutCard
                  index={index}
                  heading={val.title}
                  label={val.label}
                  targets={val.targets}
                  header={val.header}
                  planLength={plan.length}
                  currentActiveCard={val.current}
                />
              </div>
            ))}
          </>
        )}
      </BodyContainer>
    </OuterContainer>
  );
}
